import { FC } from 'react';
import parse from 'html-react-parser';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/hooks';
import { BatchModal } from '@/components/_modals';
import { CloudUploadOutlined } from '@ant-design/icons';
import { showEmailConfirmationToast } from '@/helpers';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';

import styles from './BatchUpload.module.sass';

interface BatchUploadProps {}

const BatchUpload: FC<BatchUploadProps> = () => {
  const { t } = useTranslation();
  const {
    isOpen: isOpenBatchModal,
    onOpenModal: handleOpenBatchModal,
    onCloseModal: handleCloseBatchModal,
  } = useModal();
  const isEmailConfirmed = useAppSelector(userSelectors.checkIfEmailConfirmed);

  const onOpenBatchModal = () => {
    if (!isEmailConfirmed) {
      showEmailConfirmationToast();
    } else {
      handleOpenBatchModal();
    }
  };

  return (
    <div>
      <Popover content={parse(t('translation.batch_upload_hint'))}>
        <div className={styles.csv} onClick={onOpenBatchModal}>
          <CloudUploadOutlined />
        </div>
      </Popover>

      <BatchModal isOpen={isOpenBatchModal} onClose={handleCloseBatchModal} />
    </div>
  );
};

export default BatchUpload;
